import React, { useState } from 'react';
import Editor from './Editor';
import { toast } from 'react-toastify';
import services from '../../services';
import { FiFileText, FiSave } from 'react-icons/fi';
import { styles } from './AddTemplate.styles';
import AppModal from '../../common/AppModal';

const AddTemplate = ({ showModal, handleClose, GET_ALL_TEMPLATE, EDITVALUE, editId }) => {
    const [value, setValue] = useState({
        name: EDITVALUE?.templateName || '',
        editorData: { templateData: EDITVALUE?.templateData } || '',
        subject: EDITVALUE?.subject || '',
    });

    const [focusedField, setFocusedField] = useState('');

    const HtmlString = value?.editorData || '';

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('name', value.name);
        formData.append('subject', value.subject);
        formData.append('body', HtmlString);

        try {
            !editId
                ? await services.template.CREATE_TEMPLATE(formData)
                : await services.template.UPDATE_TEMPLATE(editId, formData);
            !editId ? toast.success('Template Create Successfully.') : toast.success('Template Update Successfully.');
            GET_ALL_TEMPLATE();
            handleClose();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <AppModal
            show={showModal}
            onClose={handleClose}
            icon={<FiFileText size={17} color="#fff" />}
            title={editId ? 'Edit Template' : 'Add New Template'}
            subtitle={editId ? 'Update your email template details' : 'Create a reusable email template'}
            footer={
                <>
                    <button
                        type="button"
                        style={styles.btnCancel}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e9eaec'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        style={styles.btnSave}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                        onClick={() => {
                            if (!value.name) {
                                toast.warning('Please Enter Template Name');
                                return;
                            }
                            if (!value.subject) {
                                toast.warning('Please Enter Subject');
                                return;
                            }
                            if (!value.editorData) {
                                toast.warning('Please Enter Template Data');
                                return;
                            }
                            handleSubmit();
                        }}
                    >
                        <FiSave size={14} />
                        {editId ? 'Update Template' : 'Save Template'}
                    </button>
                </>
            }
        >
            {/* Template Name */}
            <div style={styles.formGroup}>
                <label style={styles.label}>
                    Template Name
                    <span style={styles.requiredStar}>*</span>
                </label>
                <input
                    type="text"
                    placeholder="e.g. Booking Confirmation"
                    style={{
                        ...styles.input,
                        ...(focusedField === 'name' ? styles.inputFocus : {}),
                    }}
                    value={value.name}
                    onFocus={() => setFocusedField('name')}
                    onBlur={() => setFocusedField('')}
                    onChange={(e) => {
                        setValue((prev) => ({
                            ...prev,
                            name: e.target.value.trimStart(),
                        }));
                    }}
                />
            </div>

            {/* Subject */}
            <div style={styles.formGroup}>
                <label style={styles.label}>
                    Subject
                    <span style={styles.requiredStar}>*</span>
                </label>
                <input
                    type="text"
                    placeholder="e.g. Your booking is confirmed"
                    style={{
                        ...styles.input,
                        ...(focusedField === 'subject' ? styles.inputFocus : {}),
                    }}
                    value={value.subject}
                    onFocus={() => setFocusedField('subject')}
                    onBlur={() => setFocusedField('')}
                    onChange={(e) => {
                        setValue((prev) => ({
                            ...prev,
                            subject: e.target.value.trimStart(),
                        }));
                    }}
                />
            </div>

            {/* Template Body */}
            <div style={styles.formGroup}>
                <label style={styles.editorLabel}>
                    Template Body
                    <span style={styles.requiredStar}>*</span>
                </label>
                <div
                    style={{
                        ...styles.editorWrapper,
                        ...(focusedField === 'editor' ? styles.inputFocus : {}),
                    }}
                    onFocus={() => setFocusedField('editor')}
                    onBlur={() => setFocusedField('')}
                >
                    <Editor
                        selectedPrevData={value?.editorData}
                        handleEditorChange={(data) => {
                            setValue((prev) => ({
                                ...prev,
                                editorData: data,
                            }));
                        }}
                    />
                </div>
            </div>
        </AppModal>
    );
};

export default AddTemplate;
